const getEnvironment = (): 'local' | 'development' | 'production' => {
	const host = window.location.host;

	// Check if running locally (localhost or .local domains)
	if(host.indexOf('localhost') >= 0 ||
		host.indexOf('127.0.0.1') >= 0 ||
		host.indexOf('.local') >= 0) {
		return 'local';
	}

	// Development environment (dev subdomains)
	if(host.indexOf('dev.') >= 0 ||
		host.indexOf('-dev.') >= 0) {
		return 'development';
	}

	return 'production';
};

export const resolveBaseUrl = (): string => {
	const env = getEnvironment();
	console.log(`Resolved environment: ${env}`);
	const endpoints = {
		local: 'http://localhost:5001/',
		development: 'https://api-dev.ideochrom.com/',
		production: 'https://api.ideochrom.com/'
	};

	return endpoints[env];
};
